import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesService} from "../../services/services-service.service";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {take} from "rxjs";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {RouteModel} from "../../../routes/models/route.model";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {FulfillmentService} from "../../../fulfillment/services/fulfillment-service.service";

export class DeliveriesActionMenuCtrl implements IController {
  ids: any;
  routeIds?: string[];
  routes: RouteModel[];
  onActionComplete: Function;
  onClear: Function;

  private enabledActions: any;
  public servicesRef: any;
  public printerProvider: string;
  public services: any[];


  /* @ngInject */
  constructor(private servicesService: ServicesService, private DeliveriesApiAction, private servicesFacadeService: ServicesFacadeService, private $delivery,
              private splitService: SplitService, private commonsDialogService: CommonsDialogService, private deliveriesDialogService: DeliveriesDialogService,
              private fulfillmentService: FulfillmentService) {
    this.servicesRef = this.$delivery();
  }

  $onInit() {
    this.printerProvider = this.splitService.getPrinterProvider();
    this.enabledActions = [];
  }

  openActionsMenu($mdMenu, ev) {
    this.servicesFacadeService.selectByIds(this.ids).pipe(take(1)).subscribe((services) => {
      if (!!services.length) {
        this.services = services;
        this.enabledActions = this.servicesService.getActionsByServices(services, this.routes);
        if (this.printerProvider !== 'Ikea') {
          this.removeIkeaFromExtraActions();
        }
        $mdMenu.open(ev);
      } else {
        this.servicesRef.$asyncValues(this.ids).then((services) => {
          this.services = services
          this.enabledActions = this.servicesService.getActionsByServices(services, this.routes);
          if (this.printerProvider !== 'Ikea') {
            this.removeIkeaFromExtraActions();
          }
          $mdMenu.open(ev);
        })
      }
    });
  }

  closeActionsMenu($mdMenu, ev) {
    this.enabledActions = [];
    $mdMenu.close();
  }

  onActionSelect(action, event) {
    if (action === 'PrintIkea') {
      this.commonsDialogService.printIkea(this.services);
      return;
    }

    if (action === 'Duplicate') {
      this.servicesService.onDuplicateOne(this.services[0]);
    } else if (action === 'Print') {
      if (this.services[0].serviceType === 'Operation') {
        this.servicesService.onPrint([this.services[0].id]);
      } else {
        this.deliveriesDialogService.printDelivery()
          .then((purpose) => {
            this.servicesService.onPrint([this.services[0].id], purpose);
          })
      }
    } else if (action === 'dispatchExternal') {
      this.deliveriesDialogService.dispatchStepExternal(this.services[0].fulfillmentId, this.services[0].fulfillmentStepId, event)
        .then((selectedQuote) => {
          this.fulfillmentService.dispatchStep(this.services[0].fulfillmentId, this.services[0].fulfillmentStepId, selectedQuote);
        })
    } else {
      this.DeliveriesApiAction[action](event, this.ids)
        .then((deliveryIds) => {
          if (_.isArray(deliveryIds) && deliveryIds.length) {
            const hasStatusChanged = !_.isEqual(action, 'SendToMarket') && !_.isEqual(action, 'Auction') && !_.isEqual(action, 'CreateRoute');
            this.onActionComplete({hasStatusChanged: hasStatusChanged});
          }
        })
    }
  }


  private removeIkeaFromExtraActions() {
    this.enabledActions = this.enabledActions.filter(action => {
      return action.id !== "PrintIkea";
    })
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesActionMenu', {
    bindings: {
      ids: '<',
      routeIds: '<?',
      routes: '<?',
      onActionComplete: '&',
      onClear: '&'
    },
    template: require('./deliveries-action-menu.html').default,
    controller: DeliveriesActionMenuCtrl
  });
